import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import * as generalUserRegistrations from '../../../redux/auth/signup/user-registration-req';
import { selectUserRegistrationErrors } from '../../../redux/auth/signup/selectors';

const mapStateToProps = state => ({
  errors: selectUserRegistrationErrors(state),
});

const mapDispatchToProps = {
  registrationUser: generalUserRegistrations.actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Auth/AuthSignupInvitation/enhance.js